import { toEnNumber } from '@/utils/tools';
import {
    nextTick,
} from 'vue';
/**
 * 获取文本框元素
 *
 * @param  {HTMLElement} el 元素
 * @return {HTMLElement}
 */
export const getInputElement = (el) => {
    if (el.tagName.toLowerCase() !== 'input') return el.querySelector('input');
    return el;
};

/**
 * 安装到组件实例中
 *
 * @param {Object} app 实例
 */
export const install = (app) => {
    app.directive('precision', {
        beforeMount(target, binding) {
            const el = getInputElement(target);

            el.vuePrecisionHandler = () => {
                const precision = target.getAttribute('data-precision') || 0;
                const max = target.getAttribute('data-precision-max') || 0;
                const key = target.getAttribute('data-precision-key');
                let value = toEnNumber(el.value).replace(/[^\d.]/g, '');

                value = value.replace(/^0{2,}/, '0'); // 0000 -> 0
                value = value.replace(/^0+([1-9])/, '$1'); // 00001 -> 1

                const split = value.split('.');
                const inter = split[0];
                let float = split[1];

                if (precision > 0) {
                    if (float) float = float.slice(0, precision);
                    if (!inter && float) { // .123
                        value = `0.${float}`;
                    } else if (inter && float) { // 1.23
                        value = `${inter}.${float}`;
                    } else if (inter && !float) { // 1  1.  10.
                        if (value.indexOf('.') > -1) {
                            value = `${inter}.`;
                        } else {
                            value = inter || '';
                        }
                    } else if (value === '.') { // .
                        value = '0.';
                    } else {
                        value = '';
                    }
                } else {
                    value = inter || '';
                }

                // 最大值
                if (max && parseFloat(value) > max) value = String(max);
                nextTick(() => {
                    el.value = value;

                    if (key) {
                        const keyArr = key.split('.');
                        keyArr.reduce((prev, cur) => {
                            if (Object.prototype.toString.call(prev[cur]) === '[object String]') {
                                prev[cur] = value;
                            }
                            return prev[cur];
                        }, binding.instance);
                    } else if (typeof binding.value === 'function') {
                        binding.value(value);
                    }
                });
            };

            el.addEventListener('input', el.vuePrecisionHandler);
        },
        mounted(target) {
            const el = getInputElement(target);
            if (typeof el.vuePrecisionHandler === 'function') el.vuePrecisionHandler();
        },
        unmounted(target) {
            const el = getInputElement(target);
            if (el.vuePrecisionHandler) {
                el.removeEventListener('input', el.vuePrecisionHandler);
                delete el.vuePrecisionHandler;
            }
        },
    });
};
